<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Edit Prescription</h3>
        </v-flex>
        <v-flex xs12 md6 sm9>
          <v-card>
            <v-card-title>
              <inertia-link :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments/' + treatment.id"><v-icon>mdi-arrow-left-bold-outline</v-icon> Treatments</inertia-link>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <edit-form :client="client" :visit="visit" :treatment="treatment"></edit-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const EditForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "treatments" */ '@/Components/Treatments/edit')

  export default {
    name: 'CreatePrescription',
    layout,
    props: [
      'client', 'visit', 'treatment'
    ],
    components: {
      EditForm
    },
    metaInfo () {
      return {
        title: 'Edit Prescription',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>
